import { Component, Input } from "@angular/core";
import { ApplicationSettings } from "./coresettings";

export function initialize(module: ng.IModule) {
    module.directive("hierarchyList", hierarchyList);
}

function hierarchyList(): ng.IDirective {
    return {
        scope: {
            items: "=",
            childItems: "@",
            filterBy: "@",
            displayName: "@",
            childDisplayName: "@",
            showSearch: "=",
            detailsState: "@"
        },
        restrict: "A",
        template: require("./hierarchy.list.directive.html")
    }
}

@Component({
    selector: "crew-hierarchy-list",
    template: require('./hierarchy-list.component.html')
})
export class HierarchyListComponent {

    constructor() {
        this.applicationSettings = ApplicationSettings.instance;
    }

    searchText: string;

    @Input()
    items: any[];

    @Input()
    childItems: string;

    @Input()
    filterBy: string;

    @Input()
    displayName: string;

    @Input()
    childDisplayName: string;

    @Input()
    showSearch: boolean;

    @Input()
    detailsState: string;

    applicationSettings: ApplicationSettings;

    getItems(item: any): any[] {
        return item[this.childItems];
    }

    hasItems(item: any): boolean {
        return this.getItems(item).length > 0;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/hierarchy.list.directive.ts